import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { VersionCheckHelper } from "./helper/version-check.helper";

@Component({
  selector: "app-root",
  templateUrl: "./app-main.html",
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppMain implements OnInit {
  isLoading = signal(true);
  title: string = "asah skill";
  checkVersion = inject(VersionCheckHelper);

  async ngOnInit() {
    this.isLoading.set(true);

    // Suppress harmless Finpay checkout popup errors
    const originalConsoleError = console.error;
    console.error = (...args: any[]) => {
      const errorMsg = args[0]?.toString() || "";
      if (errorMsg.includes("No checkout popup config found")) {
        // Silently ignore Finpay SDK initialization errors
        return;
      }
      originalConsoleError.apply(console, args);
    };

    try {
      await Promise.race([
        this.checkVersion.initVersionCheck("/assets/version.json"),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("Version check timeout")), 5000)
        ),
      ]);
    } catch (err) {
      console.warn("Version check skipped:", err);
    } finally {
      this.isLoading.set(false);
    }
  }
}
